import { render, staticRenderFns } from "./patternPayment.vue?vue&type=template&id=168fb661&scoped=true"
import script from "./patternPayment.vue?vue&type=script&lang=js"
export * from "./patternPayment.vue?vue&type=script&lang=js"
import style0 from "./patternPayment.vue?vue&type=style&index=0&id=168fb661&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168fb661",
  null
  
)

export default component.exports